module.exports = __webpack_public_path__ + "img/lamp.de2a54cf.svg";